import { useState, type FormEvent } from 'react';
import { AlarmClock, LockKeyhole } from 'lucide-react';
import { Button, ErrorNote, Field, Input } from '../components/ui';
import { useT } from '../lib/i18n';
import { useLogin } from '../lib/session';

export function LoginPage() {
  const t = useT();
  const login = useLogin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate({ username, password });
  };

  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-7 flex flex-col items-center gap-3 text-center">
          <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand text-on-brand">
            <AlarmClock size={24} />
          </span>
          <div>
            <h1 className="text-lg font-semibold tracking-tight text-ink">
              {t('nav.brand')}
            </h1>
            <p className="mt-1 text-sm text-ink-2">{t('login.subtitle')}</p>
          </div>
        </div>

        <form
          onSubmit={submit}
          className="space-y-4 rounded-xl border border-line bg-surface p-5 shadow-sm sm:p-6"
        >
          <Field label={t('login.username')}>
            <Input
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </Field>

          <Field label={t('login.password')}>
            <Input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>

          {login.isError && <ErrorNote error={login.error} />}

          <Button
            type="submit"
            variant="primary"
            loading={login.isPending}
            icon={<LockKeyhole size={16} />}
            className="w-full"
          >
            {t('login.submit')}
          </Button>
        </form>

        <p className="mt-4 text-center text-xs text-ink-3">
          {t('login.note')}
        </p>
      </div>
    </div>
  );
}
